import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import "./Footer.css";


export default function Footer() {
  return (
    <footer className="footer">
      {/* === TOP ROW (LOGO + SOCIALS) === */}
      <div className="footer-top">
        <div className="footer-logo-wrapper">
          <div className="footer-logo-glow"></div>
          <img src="/assets/Blue Logo White.png" alt="Jortel Logo" className="footer-logo"/>
        </div>

        <div className="footer-socials">
          <a href="https://www.facebook.com/JortelAustralia" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF/></a>
          <a href="https://au.linkedin.com/company/jortelaustralia" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn/></a>
          <a href="https://www.instagram.com/jortel_australia/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram/></a>
          <a href="https://x.com/JortelAustralia" target="_blank" rel="noopener noreferrer" aria-label="X"><FaXTwitter/></a>
        </div>
      </div>

      {/* === GRID SECTIONS === */}
      <div className="footer-grid">
        
        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/plans">Plans</Link></li>
            <li><Link to="/mobile-coverage">Coverage &amp; Outages</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Get In Touch */}
        <div className="footer-col">
          <h4>Get In Touch</h4>
          <ul>
            <li><FaPhone/> 1300 JORTEL (567 835)</li>
            <li><FaEnvelope/> info@jortel.com.au</li>
            <li><FaMapMarkerAlt/> Suite 7B, 256 New Line Road, Dural NSW 2158</li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="footer-col">
          <h4>Subscribe</h4>
          <p className="footer-subtext">
            Stay up to date with our latest news and announcements.
          </p>

          <div className="footer-input-wrapper">
            <input
              type="email"
              placeholder="Enter your email"
              className="footer-input"
            />
            <button className="footer-submit">+</button>
          </div>
        </div>

      </div>

      <div className="footer-acknowledgement">
        <p>
          Jortel acknowledges the Traditional Custodians of the land upon which
          we work, live and blend.
        </p>
        <p>
          We pay our respect to their Elders past and present and extend that
          respect to all Aboriginal and Torres Strait Islander peoples today.
        </p>
      </div>

      {/* === Bottom Bar === */}
      <div className="footer-bottom">
        <div className="footer-bottom-links">
          <Link to="/terms">Terms and Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/financial-hardship">Financial Hardship</Link>
        </div>
        <div className="footer-bottom-copy">
          © 2025 Jortel Communications. All rights reserved.
        </div>
      </div>
    </footer>
  );
}




